import * as React from "react";
import { makeStyles } from "@mui/styles";
import { Header } from "@/components/atoms/Header";
import { CentredTemplate } from "@/templates/CentredTemplate";
import { useBrandingContext } from "@/contexts/BrandingContext";

export type ForgotPasswordDoneProps = { emailAddress: string };

export const ForgotPasswordDone: React.FC<ForgotPasswordDoneProps> = ({ emailAddress }) => {
  const classes = useStyles();
  const { brand, email, tel } = useBrandingContext();

  return (
    <CentredTemplate headerType="signup">
      <Header>Email sent</Header>
      <p>
        We will send an email to <span className={classes.emailAddress}>{emailAddress}</span> if it
        is in our records. Please click on the link in the email to reset your password.
      </p>

      <p>
        If you need help logging into your account, please email us at{" "}
        <span className={classes.emailAddress}>
          <b>{email}</b>
        </span>{" "}
        or call the {brand} team on <b>{tel}</b> (office hours are 9am-5pm Monday to Friday).
      </p>

      <div style={{ paddingTop: "15px" }}></div>
    </CentredTemplate>
  );
};

const useStyles = makeStyles({
  emailAddress: {
    fontWeight: "bold",
  },
});
